import SkipTranslationWrapper from '../components/common/SkipTranslationWrapper';
import { Locale } from './constants';

const displayInYen = (amount: number | undefined, locale = 'ja', smallYen?: 'smallYen') => {
  if (amount === undefined) return '';

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'JPY',
    minimumFractionDigits: 0,
  });

  const yen = formatter
    .formatToParts(amount)
    .map(({ type, value }) => {
      switch (type) {
        case 'currency':
          return '';
        default:
          return value;
      }
    })
    .join('');

  if (smallYen === 'smallYen') {
    return (
      <SkipTranslationWrapper tag="span">
        {locale === Locale.JAPANESE ? (
          <>
            {yen}
            <span className="text-[0.6em] font-normal"> 円</span>
          </>
        ) : (
          <>
            {yen}
            <span className="text-[0.6em] font-normal"> JPY</span>
          </>
        )}
      </SkipTranslationWrapper>
    );
  }
  return (
    <SkipTranslationWrapper tag="span">
      {locale === Locale.JAPANESE ? `${yen} 円` : `${yen} JPY`}
    </SkipTranslationWrapper>
  );
};

export default displayInYen;
